import { useTranslation } from 'react-i18next';

const domains = [
  { img: '/images/generated/advanced-service-2026.jpg', icon: 'ri-goblet-line' },
  { img: '/images/generated/essential-ironing-2026.jpg', icon: 'ri-home-4-line' },
  { img: '/images/generated/schedule-hero-2026.jpg', icon: 'ri-calendar-check-line' },
  { img: '/images/generated/master-leadership-2026.jpg', icon: 'ri-team-line' },
  { img: '/images/generated/clinic-scenario-3.jpg', icon: 'ri-shield-check-line' },
];

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function WorkDomains() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.domains.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.domains.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.domains.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          {renderParagraphs(
            String(t('butlerJob.domains.lead')),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[680px] mx-auto',
          )}
        </div>

        <div className="space-y-6">
          {domains.map((domain, idx) => (
            <div
              key={idx}
              className={`flex flex-col ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-6 md:gap-10 items-stretch bg-background-50 border border-background-200/60`}
            >
              <div className="md:w-[42%] relative overflow-hidden min-h-[220px] md:min-h-[280px]">
                <img
                  src={domain.img}
                  alt={t(`butlerJob.domains.${idx}.imgAlt`)}
                  className="absolute inset-0 w-full h-full object-cover object-center"
                />
              </div>
              <div className="md:w-[58%] p-6 md:p-10 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                    <i className={`${domain.icon} text-accent-500 text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-[18px] md:text-[19px] text-foreground-900 tracking-[0.06em]">
                    {t(`butlerJob.domains.${idx}.title`)}
                  </h3>
                </div>
                {renderParagraphs(
                  String(t(`butlerJob.domains.${idx}.desc`)),
                  'text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.9]',
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
